export default {"src":"/_next/static/media/close.ea3a4300.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};